// extracted by mini-css-extract-plugin
export default {"container":"Products_container__sg1PY","products":"Products_products__c5l3u","menu":"Products_menu__MQshu","list":"Products_list__D44Y5","product":"Products_product__0PFt3"};